// extracted by mini-css-extract-plugin
export default {"root":"styles_root__ugnv2","subtitle":"styles_subtitle__yWoi9","content":"styles_content__fFAL-"};